<template>
  <v-container class="py-7" fluid>
    <router-view/>
  </v-container>
</template>

<script>
export default {
  name: "FundingSimulationIndex",
}
</script>

<style scoped>

</style>
